import { Environment } from './shared-types'

import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

export default (appContext) => {
  const stimulus = Application.start()
  // Configure Stimulus development experience
  stimulus.debug = appContext.environment === Environment.Development
  window.Stimulus = stimulus

  // eslint-disable-next-line no-undef
  const applicationContext = require.context(
    '../../controllers',
    true,
    /\.(js|ts)$/
  )

  // eslint-disable-next-line no-undef
  const viewComponentsContext = require.context(
    '../../../components',
    true,
    /controller\.(js|ts)$/
  )

  window.Stimulus.load(definitionsFromContext(applicationContext))
  window.Stimulus.load(definitionsFromContext(viewComponentsContext))

  return appContext
}
